.empty {
  margin: 0;
  color: var(--color-text-muted);
  font-size: var(--font-size-sm);
}
